<template>
  <div class="team-card">
    <div class="img-cont">
      <img class="self" :src="photo"/>
      <div style="position:absolute; width:84px;height:84px;">

      </div>
      <a :href="email">
        <img class="icon" :src="mail"/>
      </a>
    </div>
    <div class="item-cont-desc">
      <div class="item-cont-head">{{ name }}</div>
  	<div class="item-cont-cont">
  	  <span>{{ desca }}</span>
  	  <span>{{ descb }}</span>
  	  <span>{{ descc }}</span>
  	</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['photo','name', 'email', 'desca', 'descb', 'descc'],
  data () {
    return{
      mail : require('./assets/gm.png'),
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.team-card{
  box-shadow: 1px 1px 1px 1px gray;
  background-color: #2d598b;
  color: white;
  display: inline-flex;
  border-radius: 10px 10px 0 0;
  height: 106px;
  margin: 10px;
  font-size: 14px;
}
.img-cont{
  display: grid;
  padding: 5px;
}
.self{
  border-radius: 100px;
  width: 80px;
  height: auto;
}
.icon{
  height: 20px;
}
.item-cont-desc{
  display: grid;
  width: 170px;
}
.item-cont-head{
  margin: auto;
  font-size: 16px;
  text-transform: uppercase;
}
.item-cont-cont{
  background-color: #102032;
  display: grid;
  border-radius: 10px 0 0 0;
}
.item-cont-cont > span{
  margin: auto;
}
@media screen and (max-width: 480px){
  .team-card{
    box-shadow: unset;
    flex-direction: column;
    margin: 10px 0;
    width: 100%;
    height: auto;
  }

  .self{
    width: 80px;
    height: auto;
    justify-self: center;
  }
  
  .item-cont-desc{
    width: 100%;
  }
  .item-cont-cont{
    border-radius: unset;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TeamCard.vue